import React from "react";
import { Row, Col } from "@folio/stripes/components";
import { useIntl } from "react-intl";
import RenderField from "../../../components/RenderField";
import { getContactTypeTranslation } from "../../../utils/contactTypeTranslations";
export var ContactsSection = function (_a) {
    var contacts = _a.contacts;
    var intl = useIntl();
    var formatMessage = intl.formatMessage;
    if (!contacts || contacts.length === 0) {
        return (React.createElement(Row, null,
            React.createElement(Col, { xs: 12 },
                React.createElement("div", null, formatMessage({ id: "ui-br-publishers.publishers.contacts.empty" })))));
    }
    return (React.createElement(React.Fragment, null, contacts.map(function (contact, index) { return (React.createElement(Row, { key: index },
        React.createElement(Col, { xs: 12, md: 4 },
            React.createElement(RenderField, { label: formatMessage({
                    id: "ui-br-publishers.publishers.contacts.type",
                }), value: getContactTypeTranslation(intl, contact.type) })),
        React.createElement(Col, { xs: 12, md: 4 },
            React.createElement(RenderField, { label: formatMessage({
                    id: "ui-br-publishers.publishers.contacts.value",
                }), value: contact.value })),
        contact.info && (React.createElement(Col, { xs: 12, md: 4 },
            React.createElement(RenderField, { label: formatMessage({
                    id: "ui-br-publishers.publishers.contacts.info",
                }), value: contact.info }))))); })));
};
